import React from 'react';
import classNames from 'classnames';
import { themr } from 'react-css-themr';
import { CdnContext } from '../../context';

import baseNetworkPersonPickerTheme from './NetworkPersonPicker.scss';

class NetworkPersonPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            people: [],
        };
    }

    componentWillUnmount() {
        const {
            people, part, section, setAnswer,
        } = this.state;

        setAnswer({
            part,
            section,
            answer: people,
        });
    }

    validState() {
        const { people } = this.state;

        if (people.length < 1) {
            return false;
        }

        return true;
    }

    isPersonChosen(person) {
        const { people } = this.state;

        return people.indexOf(person) > -1;
    }

    handlePersonClick(person) {
        const { people } = this.state;
        const { onStateChange } = this.props;

        if (this.isPersonChosen(person)) {
            people.splice(people.indexOf(person), 1);
        } else {
            people[0] = person;
        }

        this.setState(
            {
                people,
            },
            () => onStateChange(this.validState())
        );
    }

    render() {
        const { dependData, theme, header } = this.props;

        return (
            <div>
                <h2 className="question-heading">{header.title}</h2>
                <div className="question-description">
                    <p>{header.description}</p>
                </div>

                <div className={theme.people}>
                    {dependData.map(person => (
                        <CdnContext.Consumer
                            key={person.name}
                        >
                            {cdn => (
                                <div
                                    onClick={() => {
                                        this.handlePersonClick(person.name);
                                    }}
                                    className={classNames(theme.person, {
                                        [theme.chosen]:
                                    this.isPersonChosen(person.name),
                                    })}
                                >
                                    <img src={`${cdn}assets/images/avatars/${person.avatar.filename}`} alt={person.name} />
                                    <h6 className={theme.name}>
                                        {person.name}
                                    </h6>
                                </div>
                            )}
                        </CdnContext.Consumer>

                    ))}
                </div>
            </div>
        );
    }
}

export default themr('NetworkPersonPicker', baseNetworkPersonPickerTheme)(NetworkPersonPicker);



// WEBPACK FOOTER //
// ./src/components/questions/NetworkPersonPicker.js